import { createSelector } from 'reselect';
import _ from 'lodash';
import { MAP_GIT_PROVIDERS } from 'common/constants/GitTypes';
import { getRepoFullName } from './repositories.utils';
import { JOB_STATES } from 'common/services/jobs-suites.service';

const getRepositories = ({ repositories }) => repositories || [];

export const repositoriesSelector = createSelector(
  getRepositories,
  repositories =>
    _.map(repositories, repo => ({
      ...repo,
      name: getRepoFullName(repo)
    }))
);

const isProcessingRepos = (repositories = []) => {
  if (repositories === null || !repositories.length) {
    return true;
  }

  if (
    repositories.filter(
      ({ extra }) =>
        extra?.backfill_status === JOB_STATES.initiated ||
        extra?.backfill_status === JOB_STATES.started
    ).length
  ) {
    return true;
  }

  return false;
};

export const isReposFinishedProccesingSelector = createSelector(
  getRepositories,
  repositories => !isProcessingRepos(repositories)
);

export const repositoriesByIdSelector = createSelector(
  repositoriesSelector,
  repositories => (repositories.length ? _.keyBy(repositories, 'id') : {})
);

export const repositoriesWithProviderDetails = createSelector(
  repositoriesSelector,
  repositories =>
    repositories.map(repo => ({
      ...repo,
      provider: MAP_GIT_PROVIDERS[_.get(repo, 'sensor_id')]
    }))
);

export const areAllReposConnectedToGitStream = sensorAuthId =>
  createSelector(repositoriesSelector, repositories =>
    repositories
      .filter(repo => repo.sensor_authorization_id === sensorAuthId)
      .every(repo => repo.extra.is_gitstream_enabled === true)
  );

export const areSomeReposConnectedToGitStream = sensorAuthId =>
  createSelector(repositoriesSelector, repositories => {
    const repos = repositories.filter(
      ({ sensor_authorization_id }) => sensor_authorization_id === sensorAuthId
    );
    const connectedRepos = repos.filter(
      ({ extra }) => extra.is_gitstream_enabled === true
    );
    return !!connectedRepos.length && connectedRepos.length < repos.length;
  });
